import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { AbleConfigSchema } from '../interfaces/ableConfigSchema';
import { AbleService } from '../services/able.service';

export type { AbleConfigSchema };

export const useAbleConfigSchemaVersionsQuery = (): UseQueryResult<string[]> => {
  return useQuery<string[]>({
    queryKey: ['able-config-schema-versions'],
    queryFn: () => AbleService.getAbleConfigSchemaVersions(),
    staleTime: Infinity, // List doesn't change often
    cacheTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};

export const useAbleConfigSchemaQuery = (version: string | undefined): UseQueryResult<AbleConfigSchema> => {
  return useQuery<AbleConfigSchema>({
    queryKey: ['able-config-schema', version],
    queryFn: () => AbleService.getAbleConfigSchema(version as string),
    staleTime: Infinity, // Schema doesn't change often
    cacheTime: 1000 * 60 * 60, // Cache for 1 hour
    enabled: !!version,
  });
};
